'use strict';

var _ = require('lodash');
var SystemStatusFaresReoptTransformerFactory = function SystemStatusFaresReoptTransformerFactory($rootScope, DataTransformer, momentService, UserProcessingTransformationService) {
  function SystemStatusFaresReoptTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['system-status-fares-reopt-mode'];
    this.priority = 1;
  }
  SystemStatusFaresReoptTransformer.prototype = Object.create(DataTransformer.prototype);
  SystemStatusFaresReoptTransformer.constructor = SystemStatusFaresReoptTransformer;
  SystemStatusFaresReoptTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) > -1;
  };
  SystemStatusFaresReoptTransformer.prototype.isCacheable = function () {
    return false;
  };
  SystemStatusFaresReoptTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SystemStatusFaresReoptTransformer.prototype.transform = function (data) {
    var length = data && data.domain && data.domain.length || 0;
    for (var i = 0; i < length; i++) {
      var entry = data.domain[i];
      entry.structuralCreationDate = _.isNil(entry.structuralCreationDate) ? undefined : momentService.of(entry.structuralCreationDate, momentService.FIELD.CREATED_DATE);
      entry.structuralCompletionDate = _.isNil(entry.structuralCompletionDate) ? undefined : momentService.of(entry.structuralCompletionDate, momentService.FIELD.COMPLETED_DATE);
      entry.tacticalCreationDate = _.isNil(entry.tacticalCreationDate) ? undefined : momentService.of(entry.tacticalCreationDate, momentService.FIELD.CREATED_DATE);
      entry.tacticalCompletionDate = _.isNil(entry.tacticalCompletionDate) ? undefined : momentService.of(entry.tacticalCompletionDate, momentService.FIELD.COMPLETED_DATE);
      entry.market = entry.origin + '-' + entry.destination;
      entry.foCabin = entry.cabin;
      entry.processingCarrier = entry.carrier;
      if (entry.owner) {
        entry.owner = UserProcessingTransformationService.getUserDisplayName(entry.owner);
      }
      if (entry.userName) {
        entry.userName = UserProcessingTransformationService.getUserDisplayName(entry.userName);
      }
    }
    data.domain = _.filter(data.domain, function (domain) {
      return domain.userName && domain.pos;
    });
    return data.domain;
  };
  return SystemStatusFaresReoptTransformer;
};
SystemStatusFaresReoptTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService'];
module.exports = SystemStatusFaresReoptTransformerFactory;